// Inventory source + sync cadence. We never crawl here — this is pure
// configuration; the crawler is Phase 3.
import React from 'react';
import { SelectField, SwitchField, TextField } from './fields';
import { INVENTORY_MODES, SYNC_FREQUENCIES } from './constants';

export default function InventorySection({ value, onChange }) {
  const set = (key) => (v) => onChange({ ...value, [key]: v });
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SelectField
          label="Inventory mode"
          value={value.inventory_mode}
          onChange={set('inventory_mode')}
          options={INVENTORY_MODES}
        />
        <SelectField
          label="Sync frequency"
          value={value.sync_frequency}
          onChange={set('sync_frequency')}
          options={SYNC_FREQUENCIES}
        />
      </div>
      <TextField
        label="Website URL (for crawl)"
        value={value.website_url}
        onChange={set('website_url')}
        placeholder="https://dealer.example.com/inventory"
      />
      <SwitchField
        label="Allow manual inventory upload"
        value={value.manual_inventory_upload_enabled}
        onChange={set('manual_inventory_upload_enabled')}
      />
    </div>
  );
}
